import { APP_CAN_APPS_V1, APP_CAN_APPS_V3, APP_CAN_TRACK } from 'constants/appNames';

/**
 * @function assignType
 * @param { string } appName
 * @returns { string } name
 */
function assignType(appName) {
	let name = '';

	if (appName === APP_CAN_APPS_V3) {
		name = APP_CAN_APPS_V3;
	} else if (appName === APP_CAN_TRACK) {
		name = APP_CAN_TRACK;
	} else {
		name = APP_CAN_APPS_V1;
	}

	return name;
}

export default assignType;
